<template>
    <v-container fluid> 
        <v-row shrink dense class="ma-4">
            <v-col cols="12">
                <v-card flat class="ma-2 pa-0" min-width="200px" v-if="this.resourceWidgets.length"> 
                    <v-data-iterator
                        class="pa-2"
                        :items="resourceWidgets"
                        :items-per-page.sync="resourcesPerPage"
                        :footer-props="{ itemsPerPageOptions }"
                        dense
                    >
                        <template v-slot:default="props">
                            <v-row>
                                <v-col v-for="(item,index) in props.items" :key="index"
                                    cols="4" sm="12" md="12" lg="4" class="pa-1"
                                >
                                    <v-carousel
                                        v-if="item.resources.length"
                                        height="450px"
                                        show-arrows-on-hover
                                    >
                                        <v-container v-for="(resource,i) in item.resources" :key="i">
                                            <AssetResourceView :resource="resource"></AssetResourceView>
                                        </v-container>
                                    </v-carousel>

                                    <v-card v-else class="ma-0 pa-0">
                                        <v-container>
                                            <v-row hover dense class="pa-2 ma-0 subtitle-1">
                                                <v-col>
                                                    <v-row dense class="title font-weight-medium">
                                                        Resource Widget
                                                        <v-btn icon v-on:click="DeleteWidget(item)">
                                                            <v-icon size="22" dark>mdi-delete</v-icon>
                                                        </v-btn>
                                                    </v-row>
                                                    <v-row dense>
                                                          Type: {{GetResourceType(item)}}
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </template>
                    </v-data-iterator>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="confirmDeleteDialog" max-width="400px">
            <v-card>
                <v-card color="primaryDark" dark flat class="pa-3 subtitle-1">
                    Delete Widget
                </v-card>
                <v-card-text class="pt-4">
                    Are you sure you want to delete this widget?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="confirmDeleteDialog = false">
                        Cancel
                    </v-btn>
                    <v-btn color="red" dark @click="ConfirmDeleteWidget()">
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import AssetResourceView from '../../views/assetDetail/AssetResourceView.vue'
export default {
    name: "AttributeWidgetTemplate",
    components: {
        AssetResourceView
    },
    props: {
        //Resource widget array
        resourceWidgets: {
            default : null,
            type : Array
        }
    },
    computed:{
        ...mapState("assetxpstate", [
            "section",
            "asset"
        ])
    },
    data: () => ({
        resourcesPerPage: 8,
        itemsPerPageOptions: [2, 4],
        resourceTypes: [
            { id: 0, name: "Images" },
            { id: 1, name: "3d Objects" },
            { id: 2, name: "Data" },
            { id: 3, name: "Other"}
        ],
        confirmDeleteDialog: false,
        widgetPendingDelete: null
    }),
    mounted:  function () {
    },
    methods:{
         ...mapGetters("authentication", [
            "CanUserEditAssets",
            "GetAuthHeaderObj"
        ]),
        ...mapActions("assetxpstate", [
            "DeleteWidgetFromTemplate"
        ]),

        GetResourceType(widget) {
            var type = this.resourceTypes.find(t => t.id == widget.resourceType);
            return type.name;
        },
        DeleteWidget(widget) {
            this.widgetPendingDelete = widget;
            this.confirmDeleteDialog = true;
        },
        ConfirmDeleteWidget() {
            this.confirmDeleteDialog = false;
            const widget = this.widgetPendingDelete;
            this.widgetPendingDelete = null;

            if (widget) {
                this.DeleteWidgetFromTemplate(widget.id).then( () =>{
                    this.$emit('widgetDeleted', widget);
                });
            }
        }
    },
    watch: {
    }
}
</script> 

<style scoped> 
.v-btn {
    width: 30px;
    height: 30px;
    margin: 0px;
    padding: 0px;
}
.v-icon:hover {
    color: blue;
}
.cardContent {
    margin: 0px; 
    padding: 5px;
}
</style>